module.exports = __webpack_public_path__ + "static/media/clipboard-tick.6ffa8e7a.svg";